'use strict';

function CnMovieButtonController($modal) {
  var vm = this;
  vm.$onInit = $onInit;
  vm.open = _open;

  function $onInit() {
  }

  function _open() {
    var modal = $modal({show: true, template: require('./video-modal.tpl.html'), container: 'body'});
    modal.$scope.videoUrl = vm.videoUrl;
  }


}
module.exports = CnMovieButtonController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-movie-button/cn-movie-button.controller.js
 ** module id = 72
 ** module chunks = 0
 **/